import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { rhytnameOptions } from "../../../../../../../common/parameters";
import { IRhytNameData } from "../../../../../../../common/types";
import { post } from "../../../../../../actions/general";
import { editTask } from "../../../../../../store/plan/actions";
import { RhythmSyllableType } from "../../../../../../store/user/models";
import { Checkbox, Title } from "../../../../../Form";
import Modal from "../../../../../Modal";
import AudioUploader from "../../../Common/AudioUploader";
import { IProps } from "./interfaces";
import { Container, Row } from "./styles";

const RhythmSyllableAudioUploader = ({ close, plan, taskIndex }: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const task = plan.tasks[taskIndex];
    const taskData = task.data as IRhytNameData;
    const { audios = [] } = taskData;
    const formattedRhytNameOptions = rhytnameOptions(formatMessage);
    const availableRhytNameOptions = formattedRhytNameOptions.filter(({ value }) => {
        return !audios.find(audio => audio.types.includes(value));
    }).map(({ value }) => value);
    const handleToggleSyllable = (audioIndex: number, value: RhythmSyllableType) => {
        let newTypes = [...audios[audioIndex].types];
        if (newTypes.includes(value)) {
            newTypes = newTypes.filter(type => type !== value);
        } else {
            newTypes.push(value);
        }
        const newAudios = [...audios];
        newAudios[audioIndex].types = newTypes;
        dispatch(editTask({ taskIndex, changingProp: "audios", val: newAudios }));
        dispatch(post("rhyt-name-audio-syllable-types", {
            planId: plan._id,
            index: taskIndex,
            audioIndex,
            newTypes,
        }));
    }

    return (
        <Modal close={close}>
            <Container>
                <Title>Upload rhythm syllable audio</Title>
                {audios.map((audio, index) => (
                    <div>
                        <Row>
                            <AudioUploader plan={plan} taskIndex={taskIndex} isRhytName rhytNameIndex={index} />
                        </Row>
                        <div>
                            {formattedRhytNameOptions.map(({ label, value }) => {
                                if (availableRhytNameOptions.includes(value) || audio.types.includes(value)) {
                                    return (
                                        <Checkbox
                                            label={label}
                                            checked={audio.types.includes(value)}
                                            onChange={() => handleToggleSyllable(index, value)}
                                            dark
                                        />
                                    )
                                }
                                return null;
                            })}
                        </div>
                    </div>
                ))}
                <AudioUploader plan={plan} taskIndex={taskIndex} isRhytName rhytNameIndex={-1} linkDisabled />
            </Container>
        </Modal>
    );
};

export default RhythmSyllableAudioUploader;
